import script from "./PostDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PostDetailComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__